import React, { Component } from 'react';
import 'react-tooltip/dist/react-tooltip.css'
import { Tooltip } from 'react-tooltip'
import MyButton from '../../components/MyButton/MyButton';
import Strings from 'localization/Strings';
import PaperReferencer from '../../components/PaperReferencer/PaperReferencer';
import ReferencesModal from '../../components/ReferencesModal/ReferencesModal';
import './Loss.css';

class Loss extends Component {
    state = {
        showReferencesModal: false,
    };
    constructor(props){
        super(props);
        this.onSubmit = props.onSubmit;
        this.StatModelMoreInfo = this.props?.StatModelMoreInfo;
        this.isBriefMode = props.isBriefMode || false;
    }
    showReferencesModal(){
        this.setState({showReferencesModal: true});
    }
    hideReferencesModal(){
        this.setState({showReferencesModal: false});
    }
    render () {     
        return (
            <div className='component-card-content'>
                <h4 className="heading1 text-left">{Strings.strings.Loss.Title}</h4>
                <h2 className="display1 text-left pt20">
                    {Strings.strings.Loss.Description}
                    <PaperReferencer refIndex={[4]} className="smoked100 body1-impose" onClick={() => this.showReferencesModal()} />
                </h2>
                <h2 className="sub-heading1 text-left">{Strings.strings.Loss.ExtraDescription}</h2>
                <div className="text-center pt50">
                    <div className='lossButtonList'>
                        {/* this button is hided in UK version */}
                        <MyButton type="white" dataTooltipId='lossS' className="my-button answer-button answer-button-4 loss-btn" onClick={() => this.onSubmit({ user_selection_loss: "severe" })} innerHTML={Strings.strings.Loss.Severe} />
                        <MyButton type="white" dataTooltipId='lossSP' className="my-button answer-button answer-button-4 loss-btn" onClick={() => this.onSubmit({ user_selection_loss: "severe to profound" })} innerHTML={Strings.strings.Loss.SevereToProfound} />
                        <MyButton type="white" dataTooltipId='lossP' className="my-button answer-button answer-button-4 loss-btn" onClick={() => this.onSubmit({ user_selection_loss: "profound" })} innerHTML={Strings.strings.Loss.Profound} />
                        <MyButton type="white" dataTooltipId='lossVP' className="my-button answer-button answer-button-4 loss-btn" onClick={() => this.onSubmit({ user_selection_loss: "very profound" })} innerHTML={Strings.strings.Loss.VeryProfound} />
                    </div>
                </div>
                <Tooltip id="lossS" place="bottom">
                    <div>
                        <p><strong>{Strings.strings.Loss.PureToneAverage}</strong> <br/>{Strings.strings.Loss.PTASevere}</p>
                        <p><strong>{Strings.strings.Loss.AidedCncScore}</strong> <br/>{Strings.strings.Loss.ACSSevere}</p>
                        <p><strong>{Strings.strings.Loss.BinauralEstimatedRange}</strong> <br/>{Strings.strings.Loss.BEASever}</p>
                    </div>
                </Tooltip> 
                <Tooltip id="lossSP" place="bottom">
                    <div>
                        <p><strong>{Strings.strings.Loss.PureToneAverage}</strong> <br/>{Strings.strings.Loss.PTASevereToProfound}</p>
                        <p><strong>{Strings.strings.Loss.AidedCncScore}</strong> <br/>{Strings.strings.Loss.ACSSevereToProfound}</p>
                        <p><strong>{Strings.strings.Loss.BinauralEstimatedRange}</strong> <br/>{Strings.strings.Loss.BEASevereToProfound}</p>
                    </div>
                </Tooltip> 
                <Tooltip id="lossP" place="bottom">
                    <div>
                        <p><strong>{Strings.strings.Loss.PureToneAverage}</strong> <br/>{Strings.strings.Loss.PTAProfound}</p>
                        <p><strong>{Strings.strings.Loss.AidedCncScore}</strong> <br/>{Strings.strings.Loss.ACSProfound}</p>
                        <p><strong>{Strings.strings.Loss.BinauralEstimatedRange}</strong> <br/>{Strings.strings.Loss.BEAProfound}</p>
                    </div>
                </Tooltip> 
                <Tooltip id="lossVP" place="bottom">
                    <div>
                        <p><strong>{Strings.strings.Loss.PureToneAverage}</strong> <br/>{Strings.strings.Loss.PTAVeryProfound}</p>
                        <p><strong>{Strings.strings.Loss.AidedCncScore}</strong> <br/>{Strings.strings.Loss.ACSVeryProfound}</p>
                        <p><strong>{Strings.strings.Loss.BinauralEstimatedRange}</strong> <br/>{Strings.strings.Loss.BEAVeryProfound}</p>
                    </div>
                </Tooltip>
                <ReferencesModal 
                    show={this.state.showReferencesModal} 
                    onHide={() => this.hideReferencesModal()} 
                />
            </div>
        );
    }
}

export default Loss;